import React, { FC, useMemo } from 'react';
import classNames from 'classnames';

import type { SpotReportData } from 'types/spot';

import styles from './SpotThumbnailBackground.module.scss';

interface Spot extends SpotReportData {
  isFiller: boolean;
  selectedCamAngleIndex: number;
  thumbnail?: { 300: string } | string;
}

interface SpotThumbnailBackgroundProps {
  spot: Spot;
}

const SpotThumbnailBackground: FC<SpotThumbnailBackgroundProps> = ({ spot }) => {
  const bgStyles = useMemo(() => {
    const spotCardThumbnail = spot?.thumbnail?.['300'] ?? spot?.thumbnail;

    return spotCardThumbnail
      ? {
          backgroundImage: `url(${spotCardThumbnail})`,
        }
      : undefined;
  }, [spot?.thumbnail]);

  return (
    <div
      className={classNames(styles.spotThumbnailBackground, 'quiver-spot-thumbnail-background')}
      data-testid="spot-thumbnail-background"
      style={bgStyles}
    />
  );
};

export default SpotThumbnailBackground;
